export const loadedGoogleMapsAPI = new Promise((resolve, reject) => {
  window['GoogleMapsInit'] = resolve

  if (!document.getElementById('google-map-script')) {
    let GMap = document.createElement('script')
    GMap.setAttribute('id', 'google-map-script')

    GMap.setAttribute('src',
      `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&callback=GoogleMapsInit&libraries=places&language=en`)

    document.body.appendChild(GMap)
  }
})
